<template>
  <tr>
    <td></td>
    <td>
      <div class="flex flex-wrap items-center">
        <Code
          class="whitespace-nowrap mr-2"
          chunk="2"
          :value="code"
          :color="info.theme ?? 'default'"
        />
        <div class="whitespace-nowrap">
          <span class="text-gray-700 text-sm">
            {{ name }}
          </span>
          <template v-if="info.category">
            <span class="text-sm text-gray-700">,&nbsp;</span>
            <span class="text-sm" :class="color">
              {{ info.category }}
            </span>
          </template>
          <template v-if="info.text">
            <span class="text-sm text-gray-700">, {{ info.text }}</span>
          </template>
        </div>
      </div>
    </td>
    <td :class="color">{{ formatPrice(-applied) }}</td>
  </tr>
</template>

<script>
export default {
  inheritAttrs: false,
}
</script>

<script setup>
import Code from 'Web/Shared/Code.vue';
import formatPrice from '@/helpers/formatPrice';
import rescue from '@/helpers/rescue';
import { computed } from 'vue';

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  code: {
    type: [Number, String],
    required: true,
  },
  info: {
    type: String,
    required: true,
  },
  applied: {
    type: [Number, String],
    required: true,
  },
});

const info = computed(() => rescue(() => JSON.parse(props.info), {
  text: info,
}));

const color = computed(() => ({
  default: 'text-blue-500',
  pga:     'text-bga-500',
  pgb:     'text-pgb-500',
  pgc:     'text-pgc-500',
}[info.value.theme ?? 'default']));

</script>
